export default "__VITE_ASSET__5c75417c__"